import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login/login.service';
import { SessionService } from '../session/session.service';
import { MessageService } from '../message/message.service';

@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {


  constructor(
    private session_svc: SessionService,
    private message_service: MessageService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401) {
        // auto logout if 401 response returned from api
        this.message_service.storage = 401;
        this.session_svc.logout();

        // location.reload(true);
      }

      // const error = err.error.message || err.statusText;
      // this._notifcation.success(error);
      return new Observable<HttpEvent<any>>(err);
    }))
  }
}
